<template>
  <div
    class="float-activity"
    :class="floatActivityClass"
    v-if="activityFloatImg && activityFloatUrl && !showChannel"
    @click="jumpLink"
  >
    <img class="float-activity-img" :src="activityFloatImg" alt="" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

export default {
  name: 'FloatActivity',
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      showChannel: state => state.showChannel
    }),
    ...mapGetters(['gameInfoConfig']),
    floatActivityClass() {
      return `float-activity-${this.gameId}`;
    },
    activityFloatImg() {
      return this.gameInfoConfig?.activityFloat?.img;
    },
    activityFloatUrl() {
      return this.gameInfoConfig?.activityFloat?.url;
    }
  },
  methods: {
    jumpLink() {
      sdkOpenLink({
        link: getGlobalGetGotoLink({ link: this.activityFloatUrl })
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';

.float-activity-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  cursor: pointer;
}

.float-activity-175 {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: auto;
  margin: 22px 0;
  padding: 0 22px;
}

.float-activity-410,
.float-activity-412 {
  z-index: 2;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 650px;
  width: 120px;
  margin: 0;
  padding: 0;
  border-radius: 10px;
}

@media screen and (orientation: landscape) {
  .float-activity-175 {
    z-index: 2;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 440px;
    width: 400px;
    margin: 0;
    padding: 0;
    border-radius: 10px;
  }

  .float-activity-410,
  .float-activity-412 {
    position: fixed;
    top: 520px;
    width: 200px;
  }

  .float-activity-412 {
    top: 440px;
  }
}
</style>
